import { AuthState, useIdentify } from '@hungryroot/customer';
import { type Experiments, type ExperimentVariants } from '../experiments';
import { usePostSignupExperiments } from './usePostSignupExperiments';
import { usePresignupExperiment } from './usePresignupExperiment';

export function useExperiment<T extends Experiments>(
  expId: Experiments
): ExperimentVariants<T> | undefined {
  const { authState } = useIdentify();

  const customerIsAuthenticated = authState === AuthState.isAuthenticated;
  const customerIsAnonymous = authState === AuthState.isAnonymous;
  const customerIsLoading = authState === AuthState.isLoading;

  const postSignup = usePostSignupExperiments(expId, {
    enabled: customerIsAuthenticated === true,
  });

  const preSignup = usePresignupExperiment(expId, {
    enabled: customerIsAnonymous === true,
  });

  if (customerIsLoading === true) {
    return undefined;
  }

  if (customerIsAnonymous === true) {
    return preSignup;
  }

  return postSignup;
}
